module.exports = new __parcel__URL__("empty_box.b403b876.svg").toString();